import Vue from 'vue';
import cookie from 'js-cookie';
import {SERVICE_TYPE} from '@iamteacherpc/consts/serviceType';
import {APP_CODE, APP_COOKIE_NAME, CHANNEL_ID, MEMBER_COOKIE_NAME, SERVICE_ID} from '@iamteacherpc/consts/cookie';

Object.defineProperties(Vue.prototype, {
    $isIamschoolStudent: {
        get() {
            if (cookie.get(APP_COOKIE_NAME.APP_CODE) === APP_CODE.STUDENT) {
                return true;
            }

            //NOTE APP_CODE가 반영되기 전 하위 호환성을 위하여. APP_CODE 반영 후 좀 지나면 없애도 됨
            if (cookie.get(MEMBER_COOKIE_NAME.SERVICE_ID) === SERVICE_ID.IAMSTUDENT) {
                return true;
            }

            if (this.$route.query.rst === SERVICE_TYPE.IAMSTUDENT) {
                return true;
            }

            return false;
        },
    },
    $isIamschoolParent: {
        get() {
            // $isIamschoolStudent 조건을 만족하면 다른 조건 무시
            if (this.$isIamschoolStudent) {
                return false;
            }

            const appCode = cookie.get(APP_COOKIE_NAME.APP_CODE);
            if (appCode === APP_CODE.PRIVATE_SCHOOL ||
                appCode === APP_CODE.PRIVATE_SCHOOL_ID) {
                return true;
            }

            //NOTE APP_CODE가 반영되기 전 하위 호환성을 위하여. APP_CODE 반영 후 좀 지나면 없애도 됨
            if (cookie.get(MEMBER_COOKIE_NAME.CHANNEL_ID) === CHANNEL_ID.PRIVATE_APP) {
                return true;
            }

            if (this.$route.query.rst !== SERVICE_TYPE.IAMSTUDENT && !this.$router.history.base.includes('iamteacherapp')) {
                return true;
            }

            return false;
        },
    },
    $isIamteacher: {
        get() {
            if (cookie.get(APP_COOKIE_NAME.APP_CODE) === APP_CODE.TEACHER) {
                return true;
            }

            return this.$router.history.base.includes('iamteacherapp');
        },
    },
});
